// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"af7ec0bc","453":"30538761","518":"58c54caa","700":"0306eb13","896":"cd54b203","963":"1e94f85d"}[chunkId] + ".chunk.js";
};